/** The signed-in frame: the shared shell, this app's routes, the menu's live counts. */

import type { ReactNode } from 'react';
import { AppShell } from '@connect/web-shared';

import { NAV_ADAPTER } from './nav-adapter';
import { useNavBadges } from './nav-badges';

export function AdminShell({ children }: { children: ReactNode }) {
  return (
    <AppShell adapter={NAV_ADAPTER} badges={useNavBadges()}>
      {children}
    </AppShell>
  );
}
